import * as React from "react";
import { ArticleGW } from "./ArticleGW"
import { Assert } from "./PADebug"
import { BDKalkCore } from "./BDKalkCore"

/* SelectionImportObject represents an amount and a specific choise of an article, taking into concideration its selected supplier and type of package aswell, 
   SelectionImportObject is used as a container for incoming selection data, before it is translated into an amount of a selected article.  */
export class SelectionImportObject {
    
    GenerateObjects(incomingData: string) {
        this.m_insertionIndex = 0
        this.m_selectionObjects = new Array<SelectionImportObject>()

        var obj = JSON.parse(incomingData)
        var result: Array<SelectionImportObject> = new Array < SelectionImportObject >()

        for (var pb = 0; pb < obj.length; pb++) {
            for (var g = 0; g < obj[pb].groups.length; g++) {
                for (var i = 0; i < obj[pb].groups[g].items.length; i++) {
                    const sio = new SelectionImportObject()
                    sio.m_prizeBook = obj[pb].id
                    sio.m_supplierID = ""
                    sio.m_packageID = 0
                    sio.m_groupId = obj[pb].groups[g].id
                    sio.m_groupIdTree = obj[pb].groups[g].groupId
                    sio.m_amount = obj[pb].groups[g].items[i].amount
                    sio.m_id = obj[pb].groups[g].items[i].id
                    sio.m_eanNo = obj[pb].groups[g].items[i].eanNo
                    sio.m_identifier = obj[pb].groups[g].items[i].identifier
                    sio.m_description = obj[pb].groups[g].items[i].description
                    sio.m_priceBase = obj[pb].groups[g].items[i].priceBase
                    sio.m_priceRecommended = obj[pb].groups[g].items[i].priceRecommended
                    sio.m_unit = obj[pb].groups[g].items[i].unit
                    sio.m_identifierOld = obj[pb].groups[g].items[i].identifierOld
                    sio.m_description2 = obj[pb].groups[g].items[i].description2
                    sio.m_packageUnit = obj[pb].groups[g].items[i].packageUnit
                    sio.m_packageAmount = obj[pb].groups[g].items[i].packageAmount
                    sio.m_pricePurchase = obj[pb].groups[g].items[i].pricePurchase
                    sio.m_discountFactor = obj[pb].groups[g].items[i].discountFactor
                    sio.m_nobb = obj[pb].groups[g].items[i].nobb
                    sio.m_nobbOwner = obj[pb].groups[g].items[i].nobbOwner
                    sio.m_nobbModule = obj[pb].groups[g].items[i].nobbModule
                    sio.m_priceType = obj[pb].groups[g].items[i].priceType
                    sio.m_priceFactory = obj[pb].groups[g].items[i].priceFactory
                    sio.m_processObject = this

                    if (this.m_coreReference != undefined) {
                        sio.m_coreReference = this.m_coreReference
                    }
                    else {
                        Assert(false,"SelectionImportObject.generateObjects - the core reference of the processing selection import object was not set.")
                    }
                    
                    this.m_selectionObjects.push(sio)
                }
            }
        }
    }
    
    // Access: id
    public Get_id() {
        return this.m_id
    }

    // Access: eanNo
    public Get_eanNo() {
        return this.m_eanNo
    }

    // Access: identifier
    public Get_identifier() {
        return this.m_identifier
    }

    // Access: description
    public Get_description() {
        return this.m_description
    }

    // Access: priceBase
    public Get_priceBase() {
        return this.m_priceBase
    }   

    // Access: priceRecommended
    public Get_priceRecommended() {
        return this.m_priceRecommended
    }  

    // Access: unit
    public Get_unit() {
        return this.m_unit
    }  

    // Access: identifierOld
    public Get_identifierOld() {
        return this.m_identifierOld
    }  

    // Access: description2
    public Get_description2() {
        return this.m_description2
    }  

    // Access: packageUnit
    public Get_packageUnit() {
        return this.m_packageUnit
    }

    // Access: packageAmount
    public Get_packageAmount() {
        return this.m_packageAmount
    }  

    // Access: pricePurchase
    public Get_pricePurchase() {
        return this.m_pricePurchase
    }  

    // Access: discountFactory
    public Get_discountFactor() {
        return this.m_discountFactor
    }  

    // Access: nobb
    public Get_nobb() {
        return this.m_nobb
    }

    // Access: nobbOwner
    public Get_nobbOwner() {
        return this.m_nobbOwner
    }

    // Access: nobbModule
    public Get_nobbModule() {
        return this.m_nobbModule
    }

    // Access: priceType
    public Get_priceType() {
        return this.m_priceType
    }

    // Access: itemType
    public Get_itemType() {
        return this.m_itemType
    }

    // Access: priceFactory
    public Get_priceFactory() {
        return this.m_priceFactory
    }

    // Access: priceBook
    public Get_prizeBook() {
        return this.m_prizeBook
    }

    // Access: groupIdTree
    public Get_groupIdTree() {
        return this.m_groupIdTree
    }

    // Access: groupId
    public Get_groupId() {
        return this.m_groupId
    }

    // Access: amount
    public Get_amount() {
        return this.m_amount
    }

    // Access: supplierID
    public Get_supplierID() {
        return this.m_supplierID
    }

    // Access: packageID
    public Get_packageID() {
        return this.m_packageID
    }

    // Handler for loaded ext data (this process will be passed on to BDKalkCore and then return here as a FulfillArticleLoad call
    public RecieveExtData(data: string) {

    }
    
    // InsertNextObject will go through the quered insertions to be performed and do the next one, until they are all inserted
    public InsertNextObject() {
        // If this is not the processing object, the call is transfered there instead
        if (this.m_processObject != undefined) {
            this.m_processObject.InsertNextObject()
            return
        }

        if (this.m_insertionIndex >= this.m_selectionObjects.length) {
            const dmode = this.m_coreReference.GetApp().DMode.QReport
            this.m_coreReference.GetApp().setState({ DisplayMode: dmode })
            return // insertion process terminates
        }

        const index = this.m_insertionIndex
        this.m_insertionIndex++

        // The following should insert the amount of the selection into the selected articles
        this.m_coreReference.SelectionLoadObject(this.m_selectionObjects[index])
    }

    // Adds the loaded amount for an article selection
    public CompleteAmountInsertion() {
        this.GetTargetArticle().AddAmount(this.Get_amount())
        this.InsertNextObject()
    }

    // 
    public GetTargetArticle() {
        return this.m_targetArticle
    }

    // 
    public SetTargetArticle(art: ArticleGW) {
        this.m_targetArticle = art
    }

    // 
    public SetCoreReference(core: BDKalkCore) {
        this.m_coreReference = core
    }

    // OnSelectionLoad simply passes on the handle to core, plus with a reference back to this SelectionImportObject
    public OnSelectionLoad(data: string) {
        this.m_coreReference.OnSelectionLoadObject(this, data)
    }
    
    private m_prizeBook:number
    private m_groupIdTree: string
    private m_groupId: string
    private m_amount: number
    private m_supplierID: string
    private m_packageID: number
    private m_id: string
    private m_eanNo: string
    private m_identifier: string
    private m_description: string
    private m_priceBase: number
    private m_priceRecommended: number
    private m_unit: string
    private m_identifierOld: string
    private m_description2: string
    private m_packageUnit: string
    private m_packageAmount: number
    private m_pricePurchase: number
    private m_discountFactor: number
    private m_nobb: string
    private m_nobbOwner: string
    private m_nobbModule: string
    private m_priceType: string
    private m_itemType: string
    private m_priceFactory: number
    private m_targetArticle: ArticleGW
    private m_coreReference: BDKalkCore
    private m_selectionObjects: Array<SelectionImportObject>
    private m_insertionIndex: number
    private m_processObject: SelectionImportObject
}

/* // ------------  Example of incoming data:  -----------
    [{
        "id":2,
        "description":"Optimera",
        "groups":
        [{
            "id":1289,
            "groupId":"0504195",
            "description":"REKTANGULÆR KLEDNING ROYALIMP",
            items":
            [{
                "id":"bf6a21f4-4d29-45de-ad15-90839c0f81c6",
                "eanNo":"7071536008634",
                "identifier":"7076134",
                "description":"FURU 22X098 REKT KLED BRUN",
                "priceBase":38.2400,
                "priceRecommended":38.2400,
                "unit":"LM",
                "identifierOld":"23533862",
                "description2":"ROYAL MØREROYAL BRUN RB.10",
                "packageUnit":"",
                "packageAmount":"",
                "pricePurchase":38.2400,
                "discountFactor":0.0,
                "nobb":"23533862",
                "nobbOwner":"205009",
                "nobbModule":"23533359",
                "priceType":" ",
                "itemType":"",
                "priceFactory":0.0
                },
                {
            }]
        }]
    }]
*/



// WEBPACK FOOTER //
// ./client/view/SelectionImportObject.tsx